import { NextPage } from 'next'
import { useState } from 'react'

import { PhotoProvider, PhotoView } from 'react-photo-view'
import 'react-photo-view/dist/react-photo-view.css'
import HomePageLayout from 'components/ui/Layouts/HomePageLayout'
import FeaturedEvent from 'components/home/sections/featured-event'
import { MetaTags, SubscribeModal } from 'components/shared'
import { LIST_SENDGRID_NAMES } from 'constants/constant'

import styles from '../styles/pages/Hideaway.module.scss'

const images = [
  {
    src: 'https://img.granted.co/1642687203676-hideaway.jpg',
    thumbnail: 'https://img.granted.co/600x600/1642687203676-hideaway.jpg',
  },
  {
    src: 'https://img.granted.co/1642687187089-hideaway.jpg',
    thumbnail: 'https://img.granted.co/600x600/1642687187089-hideaway.jpg',
  },
  {
    src: 'https://img.granted.co/1642687128684-hideaway.jpg',
    thumbnail: 'https://img.granted.co/600x600/1642687128684-hideaway.jpg',
  },
  {
    src: 'https://img.granted.co/1642687045980-hideaway.jpg',
    thumbnail: 'https://img.granted.co/600x600/1642687045980-hideaway.jpg',
  },
  {
    src: 'https://img.granted.co/1642687167999-hideaway.jpg',
    thumbnail: 'https://img.granted.co/600x600/1642687167999-hideaway.jpg',
  },
  {
    src: 'https://img.granted.co/1642687018108-hideaway.jpg',
    thumbnail: 'https://img.granted.co/600x600/1642687018108-hideaway.jpg',
  },
  {
    src: 'https://img.granted.co/1642687221559-hideaway.jpg',
    thumbnail: 'https://img.granted.co/600x600/1642687221559-hideaway.jpg',
  },
  {
    src: 'https://img.granted.co/1642687151151-hideaway.jpg',
    thumbnail: 'https://img.granted.co/600x600/1642687151151-hideaway.jpg',
  },
  {
    src: 'https://img.granted.co/1642687099069-hideaway.jpg',
    thumbnail: 'https://img.granted.co/600x600/1642687099069-hideaway.jpg',
  },
]

const description = `Our invitation only, private suite at Crypto.com Arena. Join the waitlist by entering your information below and a concierge member will contact you when dates becomes available. <br/><br/> For additional questions, feel free to contact us at <a href="mailto:hideaway@granted.co">hideaway@granted.co</a>. <br/><br/> Follow us on Instagram <a href="https://www.instagram.com/hideawaycrypto/" rel="noopener noreferrer" target="_blank"> @hideawaycrypto </a> for upcoming updates.`

export const getStaticProps = () => ({ props: { isPrivate: true } })

const Hideaway: NextPage = () => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <PhotoProvider>
      <MetaTags />
      <HomePageLayout>
        <SubscribeModal
          title="Join the list"
          text="A member of our concierge team will be in touch."
          visible={isOpen}
          onClose={() => setIsOpen(false)}
          sendGridListName={LIST_SENDGRID_NAMES.hideaway}
          subscribeButtonText="Join"
        />

        <FeaturedEvent
          reverse
          title="Hideaway"
          description={description}
          images={[
            {
              url: 'https://img.granted.co/1280x720/1642433069148-hideaway.jpg',
              objectFit: 'cover',
            },
          ]}
          color="green"
          headingProps={{ glow: false, color: 'white' }}
          subtitle={{ text: 'Crypto.com arena', placing: 'above' }}
          actions={[
            {
              label: 'Join the list',
              variant: 'primary',
              uppercase: true,
              onClick: () => setIsOpen(true),
            },
          ]}
        />

        <div className={styles.images}>
          {images.map(({ src, thumbnail }) => (
            <PhotoView key={src} src={src}>
              <img src={thumbnail} alt="hideaway" className={styles.image} />
            </PhotoView>
          ))}
        </div>
      </HomePageLayout>
    </PhotoProvider>
  )
}

export default Hideaway
